<template>
  <div id="popup-resident" :name="name">
    <template v-for="(item, index) in list">
      <GDialog
        v-if="item.type.startsWith('message')"
        :key="`R[${name}]_D[${index}(${item.id})]`"
        :item="item"
        @close="closeItem" />
      <Popup v-else :key="`R[${name}]_P[${index}(${item.id})]`" :item="item" @close="closeItem"></Popup>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mutations } from '@/store/common/types';
import { mapMutations, mapState } from 'vuex';
import GDialog from './GDialog.vue';
import Popup from './Popup.vue';
export default defineComponent({
  components: {
    Popup,
    GDialog,
  },
  props: {
    name: {
      type: String,
      default: 'popups',
    },
  },
  data: () => ({}),
  computed: {
    ...mapState('common', {
      list: 'popups',
    }),
  },
  methods: {
    ...mapMutations('common', {
      closePopup: mutations.CLOSE_POPUP,
    }),
    closeItem(id: string) {
      this.closePopup(id);
    },
  },
});
</script>

<style></style>
